import { readWithRecovery } from '../utils/loadWithRecovery';
import config from '../utils/config';
import { getLocalStorage } from '../utils/func';
import { abortable } from '../utils/abortable';

export function notificationRequest(path, options = {}) {
  const token = options.token === undefined ? getLocalStorage(config.token) : options.token;
  const read = ({ signal } = options) => {
    if (token !== getLocalStorage(config.token)) throw Object.assign(new Error('Session changed'), { status: 401 });
    return requestOnce(path, { ...options, token, signal });
  };
  return !options.method || options.method === 'GET' || (options.method === 'POST' && path === '/sync')
    ? readWithRecovery(read, { signal: options.signal }) : requestOnce(path, { ...options, token });
}

async function requestOnce(path, { method = 'GET', body, signal, token = getLocalStorage(config.token) } = {}) {
  const controller = new AbortController(), abort = () => controller.abort();
  if (signal?.aborted) controller.abort();
  signal?.addEventListener('abort', abort, { once: true });
  const timeout = setTimeout(abort, 10000);
  const cancelled = new DOMException('Notification request aborted', 'AbortError');
  try {
    const response = await abortable(fetch(`${process.env.REACT_APP_API_URL}/notifications${path}`, {
      method, signal: controller.signal, cache: 'no-store', headers: { 'Content-Type': 'application/json', ...(token ? { [config.token]: token } : {}) },
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    }), controller.signal, cancelled);
    let data;
    try { data = await abortable(response.json(), controller.signal, cancelled); }
    catch (error) {
      if (controller.signal.aborted) throw error;
      throw Object.assign(new Error('NOTIFICATIONS_UNAVAILABLE'), { status: response.status });
    }
    if (!response.ok || data.success !== true) {
      const error = new Error(data.error || 'NOTIFICATIONS_UNAVAILABLE'); error.status = response.status; error.retryAfter = Number(response.headers?.get('Retry-After')) || 0; throw error;
    }
    return data;
  } finally { clearTimeout(timeout); signal?.removeEventListener('abort', abort); }
}

export function notificationTarget(value) {
  if (value?.type === 'opinion' && Number.isSafeInteger(value.id) && value.id > 0) return `/opinion/${value.id}`;
  if (value?.type === 'user' && typeof value.username === 'string' && value.username.length <= 100
    && !/[/?#\\]/.test(value.username) && ![...value.username].some(char => char.charCodeAt(0) < 32)) return `/user/${encodeURIComponent(value.username)}`;
  return null;
}
